import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import Subheading from '../../../../typography/Subheading'
import AccessibleIcon from '../../../../elements/AccessibleIcon'

import styles from './styles'

const Title = ({ title, subtitle, icon, iconColor, className }) => (
  <Subheading className={cx(styles.title, className)}>
    {Boolean(icon) && <AccessibleIcon icon={icon} size={20} color={iconColor} className={styles.icon} />}
    <strong>{title}</strong>
    {subtitle}
  </Subheading>
)

Title.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  iconColor: PropTypes.string,
  className: PropTypes.string,
}

export default Title
